<ng-container [ngSwitch]="media">
    <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
    <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
</ng-container>

<ng-template #homefilterdesk>
    <div class="tmp-inputs-wrapper w100">
        <div class="tmp-inputbody glb">
            <div class="tmp-principal-wrapper">
                <button class="tmpbtn w100 tmp-left tmp-right mr5" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
                    (click)="openModal($event)" matRipple>
                    <span class="ellipsis">{{zielText}}</span>
                </button>
                <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
                    [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
                    [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
                    <ng-container *ngTemplateOutlet="deskModal"></ng-container>
                </ng-template>
            </div>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoSearch($event)" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>SUCHEN</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">
        <div class="body-mobile w100">
            <div class="tmp-principal-wrappermb">
                <button class="tmpbtn w100 tmpnobottomborder tmp-top glb-mobile" #mdbuttonMobile="cdkOverlayOrigin"
                    cdkOverlayOrigin (click)="openModalMobile($event)" matRipple>
                    <span class="ellipsis w100">{{zielText}}</span>
                </button>
                <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
                    [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
                    [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
                    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
                </ng-template>
            </div>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100" (click)="gotoSearch($event)" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>SUCHEN</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #deskModal>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" ng-focus [appAutoFocus]="focus" class="tmpangebotsktvinput"
                    (paste)="detectPast($event)" [formControl]="mySearchControl" placeholder="{{zielText}}"
                    (keydown.enter)="gotoSearch($event)">

                <ng-container *ngIf="!loading else myloading">
                    <button class="tmp_srchbtn" (click)="gotoSearch($event)" aria-label="search" matRipple>
                        <mat-icon>search</mat-icon>
                    </button>
                </ng-container>
            </div>
            <ng-container *ngTemplateOutlet="datassectiondesk"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple class="mr5" (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" placeholder="{{zielText}}" (paste)="detectPast($event)"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus" class="searchinput">
                <ng-container *ngIf="!loading else myloading">
                    <button class="tmp_srchbtn" (click)="gotoSearch($event)" aria-label="Search" matRipple>
                        <mat-icon>search</mat-icon>
                    </button>
                </ng-container>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="cc50wrappermobile">
        <ng-container *ngIf="showglobalsearchres">
            <ng-container *ngIf="searchres?.length > 0 else notfound">
                <div class="cc50mobile customscroll" (scroll)="$event.stopPropagation()">
                    <ng-container *ngFor="let obj of searchres">
                        <button class="cc50-itemmobile" (click)="gotofirst(obj, $event)">
                            <div class="cc51mobile">
                                <ng-container *ngIf="obj?.sktvbestellnummer?.length > 0">
                                    <div class="ccsjtv" [innerHtml]="obj.sktvbestellnummer | safehtml"></div>
                                </ng-container>
                                <!-- <span class="cc50-title">{{obj.name}}</span> -->
                                <div class="cc50-title" [innerHtml]="obj.displayname | safehtml"></div>
                                <ng-container *ngIf="obj.subtext?.length > 0">
                                    <span class="cc50-item-subtext">{{obj.subtext}}</span>
                                </ng-container>
                            </div>
                            <div class="cc52mobile">
                                <button class="cc53mobile" *ngIf="obj.isPauschal"
                                    (click)="gotoPauschal(obj, $event)">Pauschal</button>
                                <button class="cc53mobile" *ngIf="obj.isHotelonly"
                                    (click)="gotoHotel(obj, $event)">Hotel</button>
                                <button class="cc53mobile" *ngIf="obj.isRailtravel" (click)="gotoRail(obj, $event)">Bahn
                                    +
                                    Hotel</button>
                                <button class="cc53mobile" *ngIf="obj.isFlight"
                                    (click)="gotoFlight(obj, $event)">Flug</button>
                                <button class="cc53mobile" *ngIf="obj.isCarrent"
                                    (click)="gotoCarrent(obj, $event)">Mietwagen</button>
                                <button class="cc53mobile" *ngIf="obj.isCruise"
                                    (click)="gotoCruise(obj, $event)">Kreuzfahrten</button>
                                <button class="cc53mobile"
                                *ngIf="obj.isFerienhauser"
                                    (click)="gotoFerienhauser(obj, $event)">Ferienhäuser</button>
                                <button class="cc53mobile" *ngIf="obj.isContent"
                                    (click)="gotoContent(obj, $event)">Reisebericht</button>
                                <button class="cc53mobile" *ngIf="obj.isTvangebote"
                                    (click)="gotoSktv(obj, $event)">TV-Angebote</button>
                            </div>
                        </button>
                    </ng-container>
                </div>
                <div class="cc50footer">
                    <button class="wbtn" (click)="gotoSearch($event)" matRipple>weitere Ergebnisse anzeigen</button>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #datassectiondesk>
    <div class="cc50wrapper">
        <ng-container *ngIf="showglobalsearchres">
            <ng-container *ngIf="searchres?.length > 0 else notfound">
                <div class="cc50 customscroll">
                    <ng-container *ngFor="let obj of searchres">
                        <button class="cc50-item" (click)="gotofirst(obj, $event)">
                            <div class="cc51">
                                <ng-container *ngIf="obj?.sktvbestellnummer?.length > 0">
                                    <div class="ccsjtv" [innerHtml]="obj.sktvbestellnummer | safehtml"></div>
                                </ng-container>
                                <!-- <span class="cc50-title">{{obj.name}}</span> -->
                                <div class="cc50-title" [innerHtml]="obj.displayname | safehtml"></div>
                                <ng-container *ngIf="obj.subtext?.length > 0">
                                    <span class="cc50-item-subtext">{{obj.subtext}}</span>
                                </ng-container>
                            </div>
                            <div class="cc52">
                                <button class="cc53" *ngIf="obj.isPauschal"
                                    (click)="gotoPauschal(obj, $event)">Pauschal</button>
                                <button class="cc53" *ngIf="obj.isHotelonly"
                                    (click)="gotoHotel(obj, $event)">Hotel</button>
                                <button class="cc53" *ngIf="obj.isRailtravel" (click)="gotoRail(obj, $event)">Bahn +
                                    Hotel</button>
                                <button class="cc53" *ngIf="obj.isFlight"
                                    (click)="gotoFlight(obj, $event)">Flug</button>
                                <button class="cc53" *ngIf="obj.isCarrent"
                                    (click)="gotoCarrent(obj, $event)">Mietwagen</button>
                                <button class="cc53" *ngIf="obj.isCruise"
                                    (click)="gotoCruise(obj, $event)">Kreuzfahrten</button>
                                <button class="cc53"
                                *ngIf="obj.isFerienhauser"
                                    (click)="gotoFerienhauser(obj, $event)">Ferienhäuser</button>
                                <button class="cc53" *ngIf="obj.isContent"
                                    (click)="gotoContent(obj, $event)">Reisebericht</button>
                                <button class="cc53" *ngIf="obj.isTvangebote"
                                    (click)="gotoSktv(obj, $event)">TV-Angebote</button>
                            </div>
                        </button>
                    </ng-container>
                </div>
                <div class="cc50footer">
                    <button class="wbtn" (click)="gotoSearch($event)" matRipple>weitere Ergebnisse anzeigen</button>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>


<ng-template #myloading>
    <mat-spinner [diameter]="22"></mat-spinner>
</ng-template>

<ng-template #notfound>
    <div class="cc54">Keine Ergebnisse gefunden</div>
</ng-template>